import { createAction } from '@reduxjs/toolkit'

// Employee actions
export const getMySubmissions = createAction('reimbursements/getMySubmissions')

// Admin actions
export const getAllEmployeeSubmissions = createAction(
  'reimbursements/getAllEmployeeSubmissions'
)

export const getEmployeeSubmissions = createAction<string>(
  'reimbursements/getEmployeeSubmissions'
)

export const getReceiptDetails = createAction<string>(
  'reimbursements/getReceiptDetails'
)
